import React from 'react'
import { ParsedSeedQuestion, buildTarotNewReadingMessage } from './hooks/seedQuestionTagUtils'
import { randomHex } from './utils/randomHex'
import { makeIcon } from '../OracleCommons/icons'

interface TarotNewReadingFABProps {
  seed: ParsedSeedQuestion | null
  sendChat: (message: string) => void
  isOperationInProgress?: boolean
  isCurrentMonth?: boolean
}

export const TarotNewReadingFAB: React.FC<TarotNewReadingFABProps> = ({
  seed,
  sendChat,
  isOperationInProgress = false,
  isCurrentMonth = true,
}) => {
  if (!seed || !isCurrentMonth || isOperationInProgress) {
    return null
  }

  const handleClick = () => {
    const salt = randomHex(8)
    sendChat(buildTarotNewReadingMessage(seed.question, salt))
  }

  return (
    <button
      type="button"
      className="tarot-new-reading-fab"
      onClick={handleClick}
    >
      <span className="tarot-new-reading-fab__icon">
        {makeIcon('plus', '16px')}
      </span>
      {seed.question}
    </button>
  )
}
